module.exports = __webpack_public_path__ + "img/st40.6e37bddf.png";